export default "__VITE_ASSET__hOv7pAyG__"